import { createFileRoute } from "@tanstack/react-router";
import { StoreDashboardPage } from "./-components/store-dashboard-page";

export const Route = createFileRoute("/store/dashboard")({
  loader: ({ context: { store } }) => ({ store }),
  component: RouteComponent,
});

function RouteComponent() {
  const { store } = Route.useLoaderData();

  return <StoreDashboardPage store={store} />;
}
